import { render, staticRenderFns } from "./TagMobile.vue?vue&type=template&id=6796ae25&scoped=true"
import script from "./TagMobile.vue?vue&type=script&lang=js"
export * from "./TagMobile.vue?vue&type=script&lang=js"
import style0 from "./TagMobile.vue?vue&type=style&index=0&id=6796ae25&prod&lang=scss&scoped=true"
import style1 from "./TagMobile.vue?vue&type=style&index=1&id=6796ae25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796ae25",
  null
  
)

export default component.exports